export enum UploadType {
  APK = "APK", IPA = "IPA", Attachment = "Attachment"
}
